import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import * as Actions from 'containers/Home/actions';
import * as ComponentActions from './actions';
import TapRating from 'containers/TapRating/TapRating';
import TappableComponentsHeader from 'components/TappableComponentsHeader/TappableComponentsHeader';
import Navigation from 'components/Navigation/Navigation';
import './Components.scss';

class Components extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const surveyData = this.props.surveyData;
        const locationIndex = this.props.locationIndex;
        const currentQuestion = surveyData.StaySubmissions[locationIndex].ComponentQuestion;
        const stayComponents = currentQuestion.Components;
        const componentsClasses = classNames('wrapper components', {
            'inactive': this.props.isDataPosting
        });

        return (
            <section className={componentsClasses}>
                {surveyData.IsBackup && (
                    <TappableComponentsHeader locationIndex={locationIndex} stays={surveyData.StaySubmissions} />
                )}

                <TapRating
                    actions={this.props.componentActions}
                    locationIndex={locationIndex}
                    stayComponents={stayComponents}
                    surveyData={surveyData}
                />

                <Navigation 
                    actions={this.props.actions}
                    didDirtyPostFail={this.props.didDirtyPostFail}
                    didPostFail={this.props.didPostFail}
                    history={this.props.history}
                    individualID={this.props.individualID}
                    isDataPosted={this.props.isDataPosted}
                    isDataPosting={this.props.isDataPosting}
                    isMobilePhone={true}
                    isNoInternet={this.props.isNoInternet}
                    isSubmit={true} 
                    locationIndex={this.props.locationIndex}
                    nextLink='/'
                    prevLink='/PulseCheck'
                    prodTourID={this.props.prodTourID}
                    surveyData={this.props.surveyData}
                />
            </section>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        didDirtyPostFail: state.surveyReducer.didDirtyPostFail,
        didPostFail: state.surveyReducer.didPostFail,
        individualID: state.dataReducer.individualID,
        isDataPosted: state.surveyReducer.isDataPosted,
        isDataPosting: state.surveyReducer.isDataPosting,
        isNoInternet: state.surveyReducer.isNoInternet,
        locationIndex: state.surveyReducer.locationIndex,
        prodTourID: state.dataReducer.prodTourID,
        surveyData: state.surveyReducer.surveyData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Actions, dispatch),
        componentActions: bindActionCreators(ComponentActions, dispatch)
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Components));



// WEBPACK FOOTER //
// ./application/containers/Components/Components.jsx